import axiosInstance from "../helper/axiosIntanceApiZalo";
import axios from '../helper/axiosIntance';
import { normalizeStringInObject } from "../utils/normalize";

function getFormData(object) {
    const formData = new FormData();
    if(object){
        Object.keys(object).forEach(key => formData.append(key, object[key]));
    }
    return formData;
}
const find_temp = (params)=>{
    return axios.post('/sms/api/listTemp', getFormData(normalizeStringInObject(params)));
}

const create_temp = (params)=>{
    return axios.post('/sms/api/createTemplate', getFormData(normalizeStringInObject(params)));
}

const delete_temp = (params)=>{
    return axios.post('/sms/api/deleteTemplate', getFormData(normalizeStringInObject(params)));
}

const findone_temp = (params)=>{
    return axios.post('/sms/api/findoneTemplate', getFormData(normalizeStringInObject(params)));
}

const update_temp = (params)=>{
    return axios.post('/sms/api/updateTemplate', getFormData(normalizeStringInObject(params)));
}

const find_campaign_running = (params)=>{
    return axios.post('/sms/api/listCampaignRunning', getFormData(params));
}

const find_campaign_complete = (params)=>{
    return axios.post('/sms/api/listCampaignEnd', getFormData(params));
}

const switch_flag = (params)=>{
    return axios.post('/sms/api/switchflagCampaign', getFormData(params));
}

const finish_campaign = (params)=>{
    return axios.post('/sms/api/finishCampaign', getFormData(params));
}

const detail_campaign = (params)=>{
    return axios.post('/sms/api/detailCampaign', getFormData(params));
}

const render_template_queue = (params)=>{
    return axios.post('/sms/api/renderTemplate', getFormData(params));
}

const add_campaign = (params)=>{
    return axios.post('/sms/api/createCampaign', getFormData(params));
}

const get_template = (params)=>{
    return axios.post('/sms/api/getTemplate', getFormData(params));
}

const get_brandname = (params)=>{
    return axios.post('/sms/api/getBrandName', getFormData(params));
}

const create_queue_all = (params)=>{
    return axios.post('/sms/api/createQueueAll', params);
}

const create_queue_otp = (params)=>{
    return axios.post('/sms/api/createQueueOTP',params);
}

const list_queue = (params)=>{
    return axios.post('/sms/api/listQueueSMS',params);
}

const download_excel_template_all = (params)=>{
    return axios.post('/sms/api/DownloadTemplateAll',params);
}

const download_excel_template_fw = (params)=>{
    return axios.post('/sms/api/DownloadTemplateForward',params);
}

const import_excel_all = (params)=>{
    return axios.post('/sms/api/ImportQueueAll',params);
}

const import_excel_fw = (params)=>{
    return axios.post('/sms/api/ImportQueueOTP',params);
}

const detail_queue = (params)=>{
    return axios.post('/sms/api/detailQueue',params);
}

const history_queue = (params)=>{
    return axios.post('/sms/api/historyQueue',getFormData(params));
}

const find_campaign_total = (params)=>{
    return axios.post('/sms/api/findCampaignTotal',params);
}

const find_campaign_comp = (params)=>{
    return axios.post('/sms/api/findCampaignComp',getFormData(params));
}

const chart_pie_report = (params)=>{
    return axios.post('/sms/api/ChartPie',getFormData(params));
}

const chart_report = (params)=>{
    return axios.post('/sms/api/chartAll',getFormData(params));
}

const quick_send_messages = (params)=>{
    return axios.post('/sms/api/quickSendMessage',params);
}

const count_queue_total = (params)=>{
    return axios.post('/sms/api/queueTotal',params);
}

const manage_info = (params)=>{
    return axios.post('/sms/api/manageInfo',params);
}

export default {
    find_temp,
    create_temp,
    delete_temp,
    findone_temp,
    update_temp,
    find_campaign_running,
    find_campaign_complete,
    switch_flag,
    finish_campaign,
    detail_campaign,
    render_template_queue,
    add_campaign,
    get_template,
    get_brandname,
    create_queue_all,
    create_queue_otp,
    list_queue,
    download_excel_template_all,
    import_excel_all,
    download_excel_template_fw,
    import_excel_fw,
    detail_queue,
    history_queue,
    find_campaign_total,
    find_campaign_comp,
    chart_pie_report,
    chart_report,
    quick_send_messages,
    count_queue_total,
    manage_info
}
